import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useUspContext } from "@/components/Blocks/usps/components/context/usp.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Content = ({ className, children }: Props) => {
    const { usp } = useUspContext();

    if (usp.link) {
        return (
            <a
                className={cn(className)}
                href={usp.link}
            >
                {children}
            </a>
        );
    } else {
        return <div className={cn(className)}>{children}</div>;
    }
};
